module.exports = __webpack_public_path__ + "static/img/baas_product_3.71eb17d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_product_3.svg
// module id = VtvI
// module chunks = 0